import React from "react";
import Teslalogo from "../Assets/Tesla-logo.png"
import NitGoalogo from "../Assets/NitGoa-logo.png"
import "./Home.css"
// import THREE from 'three'
// const scene = new THREE.Scene




const Home = () => {
  setInterval(light, 1000);

  function light() {
    const light1 = document.getElementById("Lightning1");
    const light2 = document.getElementById("Lightning2");
    const light3 = document.getElementById("Lightning3");

    if (light1 && light2 && light3) {
      if (light1.style.visibility === "visible") {
        light1.style.visibility = "hidden";
        light2.style.visibility = "visible";
        light3.style.visibility = "hidden";
      } else if (light2.style.visibility === "visible") {
        light1.style.visibility = "hidden";
        light2.style.visibility = "hidden";
        light3.style.visibility = "visible";
      } else {
        light1.style.visibility = "visible";
        light2.style.visibility = "hidden";
        light3.style.visibility = "hidden";
      }
    }
  }

  setInterval(lightRight, 1000);

  function lightRight() {
    const light1 = document.getElementById("Lightning-1-right");
    const light2 = document.getElementById("Lightning-2-right");
    const light3 = document.getElementById("Lightning-3-right");

    if (light1 && light2 && light3) {
      if (light1.style.visibility === "visible") {
        light1.style.visibility = "hidden";
        light2.style.visibility = "visible";
        light3.style.visibility = "hidden";
      } else if (light2.style.visibility === "visible") {
        light1.style.visibility = "hidden";
        light2.style.visibility = "hidden";
        light3.style.visibility = "visible";
      } else {
        light1.style.visibility = "visible";
        light2.style.visibility = "hidden";
        light3.style.visibility = "hidden";
      }
    }
  }
  return (
    <div className="home" id="Home">

      <img className="Tesla-logo" src={Teslalogo} alt="" />
      <img className="Nit-Goa-logo" src={NitGoalogo} alt="" />
      <svg
        className="Lightning-left "
        viewBox="0 0 100 2000"
        width="100"
        height="2000"
      >
        <g>
          <path
            id="Lightning1"
            d="M38 2000L17 1889L32 1778L49 1667L5 1556L14 1444L13 1333L35 1222L10 1111L7 1000L6 889L17 778L2 667L26 556L81 444L23 333L67 222L58 111L60 0L99 0L86 111L76 222L58 333L90 444L40 556L41 667L58 778L48 889L45 1000L47 1111L64 1222L58 1333L35 1444L45 1556L87 1667L72 1778L37 1889L59 2000Z"
            fill="#fecc02"
          ></path>
          <path
            id="Lightning2"
            d="M41 2000L1 1889L33 1778L2 1667L27 1556L44 1444L4 1333L29 1222L15 1111L32 1000L9 889L30 778L20 667L23 556L8 444L41 333L27 222L26 111L29 0L82 0L88 111L28 222L82 333L68 444L51 556L35 667L80 778L42 889L85 1000L93 1111L66 1222L27 1333L99 1444L91 1556L55 1667L44 1778L3 1889L81 2000Z"
            fill="#fecc02"
          ></path>
          <path
            id="Lightning3"
            d="M17 2000L31 1889L36 1778L29 1667L10 1556L8 1444L47 1333L6 1222L5 1111L10 1000L43 889L42 778L38 667L38 556L9 444L23 333L35 222L29 111L43 0L58 0L76 111L84 222L60 333L24 444L80 556L70 667L61 778L93 889L47 1000L40 1111L38 1222L95 1333L9 1444L45 1556L79 1667L47 1778L38 1889L64 2000Z"
            fill="#fecc02"
          ></path>
        </g>
      </svg>

      <svg
        className="Lightning-right"
        viewBox="0 0 100 2000"
        width="100"
        height="2000"
        version="1.1"
      >
        <path
          id="Lightning-1-right"
          d="M17 2000L31 1889L36 1778L29 1667L10 1556L8 1444L47 1333L6 1222L5 1111L10 1000L43 889L42 778L38 667L38 556L9 444L23 333L35 222L29 111L43 0L58 0L76 111L84 222L60 333L24 444L80 556L70 667L61 778L93 889L47 1000L40 1111L38 1222L95 1333L9 1444L45 1556L79 1667L47 1778L38 1889L64 2000Z"
          fill="#fecc02"
        ></path>
        <path
          id="Lightning-2-right"
          d="M79 2000L51 1833L21 1667L17 1500L21 1333L21 1167L21 1000L2 833L49 667L69 500L49 333L32 167L43 0L63 0L33 167L59 333L80 500L88 667L30 833L35 1000L52 1167L35 1333L46 1500L71 1667L67 1833L94 2000Z"
          fill="#fecc02"
        ></path>
        <path
          id="Lightning-3-right"
          d="M16 2000L57 1889L56 1778L48 1667L8 1556L12 1444L29 1333L7 1222L32 1111L69 1000L14 889L35 778L84 667L50 556L39 444L11 333L5 222L53 111L27 0L38 0L80 111L53 222L52 333L85 444L96 556L85 667L84 778L44 889L77 1000L75 1111L53 1222L77 1333L14 1444L41 1556L78 1667L74 1778L89 1889L56 2000Z"
          fill="#fecc02"
        ></path>
      </svg>

      <div> 
        <div className="logo">
          <h1>Welcome to Tesla Club!</h1>
          <p>Welcome to Tesla Club at NIT Goa's EEE Department! We're a vibrant community passionate about innovation, collaboration, and sustainability in electrical and electronics engineering. Join us to explore cutting-edge technology, foster creativity, and make a positive impact. Let's ignite our curiosity and drive towards a brighter, greener future together. Welcome aboard!</p>
        </div>
        
      </div>
      <div className="Workshop-top spacer"></div>
    </div>
  );
};

export default Home;
